/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/no-multi-comp */
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, TableCell } from '@material-ui/core';
import { Table } from '../../../components';
import ManutencaoFormulario from './ManutencaoFormulario';
import { moneyFormatter } from 'utils';

const useStyles = makeStyles(() => ({
  fieldContainer: {
    paddingBottom: '0px !important'
  }
}));

const ManutencaoVeicularContainer = ({ manutencoes, onSave, readOnly }) => {
  const classes = useStyles();

  const [currentManutencoes, setCurrentManutencoes] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedManutencao, setSelectedManutencao] = useState(null);

  useEffect(() => {
    if (manutencoes) {
      setCurrentManutencoes(manutencoes);
    }
  }, [manutencoes]);

  const renderRows = m => (
    <>
      <TableCell>{m.tipoManutencaoNome}</TableCell>
      <TableCell>{moneyFormatter(m.valor)}</TableCell>
      <TableCell>{m.quantidade}</TableCell>
      <TableCell>{m.descricao}</TableCell>
    </>
  );

  const onDeleteLocal = id => {
    const updated = currentManutencoes.filter(m => m.id !== id);
    setCurrentManutencoes(updated);
    onClose(updated);
  };

  const onClose = manutencoesToRetrieve => {
    setOpen(false);
    setSelectedManutencao(null);
    onSave(manutencoesToRetrieve || currentManutencoes);
  };

  const onUpsert = data => {
    let updated = [];
    const exists = currentManutencoes.filter(m => m.id === data.id);
    if (exists.length > 0) {
      currentManutencoes.forEach(m => {
        updated.push(m.id === data.id ? data : m);
      });
    } else {
      updated = [...currentManutencoes, data];
    }
    setCurrentManutencoes(updated);
    onClose(updated);
  };

  const onEdit = id => {
    setSelectedManutencao(currentManutencoes.filter(m => m.id === id)[0]);
    setOpen(true);
  };

  return (
    <>
      <Grid item xs={12} className={classes.root}>
        <Table
          rows={currentManutencoes}
          titles={['Tipo', 'Valor', 'Qtd', 'Descrição']}
          headerTitle="Manutenções"
          deleteMessage="Tem certeza que deseja remover a manutenção"
          renderRows={renderRows}
          hasRowActions
          onDelete={onDeleteLocal}
          onEdit={onEdit}
          hasAdd={!readOnly}
          showDelete={!readOnly}
          showEdit={!readOnly}
          onAdd={() => setOpen(true)}
          showEmptyState={false}
        />
      </Grid>
      <ManutencaoFormulario
        selectedManutencao={selectedManutencao}
        open={open}
        onClose={onClose}
        onSave={onUpsert}
      />
    </>
  );
};

export default ManutencaoVeicularContainer;
